import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const TriangleIcon = createIcon({
  displayName: 'TriangleIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,4l-9,16h18Z"
        ></path>
      </g>
    </>
  ),
})

const Triangle: FC<IconProps> = (props) => {
  return <CustomIcon as={TriangleIcon} {...props} />
}

export default memo(Triangle)
